import { normaliseAuState, type ZohoContact } from '@deltasuite/zoho-client';

interface Props {
  contacts: readonly ZohoContact[];
  total: number;
  limit?: number;
}

function fullName(c: ZohoContact): string {
  return [c.First_Name, c.Last_Name].filter(Boolean).join(' ');
}

export function ContactList({ contacts, total, limit = 30 }: Props) {
  const shown = contacts.slice(0, limit);

  if (total === 0) {
    return (
      <div className="rounded-lg border border-dashed border-graphite-300 bg-surface-sunk p-8 text-center">
        <p className="font-sans text-sm text-graphite-700">No contacts match the current filter.</p>
        <p className="mt-1 font-mono text-xs text-graphite-500">
          Adjust state or contact-type chips to widen the pool.
        </p>
      </div>
    );
  }

  return (
    <ul className="divide-y divide-graphite-100 rounded-lg border border-graphite-100 bg-surface">
      {shown.map((c) => {
        const code = normaliseAuState(c.Mailing_State);
        return (
          <li key={c.id} className="flex items-baseline justify-between gap-4 px-4 py-3">
            <div className="min-w-0">
              <p className="truncate font-sans text-sm text-graphite-900">{fullName(c)}</p>
              <p className="truncate font-mono text-[0.7rem] text-graphite-500">
                {c.Title ? `${c.Title} · ` : ''}
                {c.Account_Name?.name ?? ''}
              </p>
            </div>
            <div className="flex shrink-0 items-baseline gap-3 font-mono text-[0.7rem] text-graphite-500">
              {c.Company_Type ? <span>{c.Company_Type}</span> : null}
              {code ? <span className="text-graphite-900">{code}</span> : null}
              {c.Mobile ? <span aria-label="has mobile">●</span> : null}
            </div>
          </li>
        );
      })}
      {total > shown.length ? (
        <li className="px-4 py-3 text-center font-mono text-[0.7rem] text-graphite-500">
          {total - shown.length} more …
        </li>
      ) : null}
    </ul>
  );
}
